import React, { useEffect, useState, useRef } from 'react';
import {SurveyManager} from "../../components/SurveyManager/SurveyManager";
import "survey-creator-core/i18n/italian";
import { json } from "./survey_json.js";
import { editorLocalization } from "survey-creator-core";
import useSurveyTemplate from '../../hooks/useSurveyTemplate.js';
import { useLocation, useNavigate } from 'react-router';
import { Spinner } from 'react-bootstrap';

editorLocalization.currentLocale = "it";

const SurveyCreatorPage = () => {
    const [loading, setLoading] = useState(true);
    const [existingTemplate, setExistingTemplate] = useState(null);
    const templateRef = useRef({ isNew: false, id: null });
    const { createSurveyTemplate, updateSurveyTemplate, getSurveyTemplateByIdContenuto} = useSurveyTemplate();
    const { courseData, selectedContenuto } = useLocation().state;
    const navigate = useNavigate();

    let options = {
        questionTypes: ["radiogroup"],
        showJSONEditor: true,
        showPropertyGrid: true,
        haveCommercialLicense: true,
        showDesignerTab: true,
        showPreviewTab: true,
        showLogicTab: false,
        showTranslationTab: false,
        showEmbeddedSurveyTab: false,
        showThemeTab: false
    };

    const onCreatorReady = (creator) => {
        creator.toolbar.addAction({
            id: "back-button",
            visible: true,
            title: "Torna ai contenuti",
            action: () => navigate("/aggiungi-contenuti", { 
                state: { createdCorso: courseData }
            }),
            icon: "icon-arrow-left",
            showTitle: true,
            location: 'left'
        });
    };

    useEffect(() => {
        if(!courseData) {
            navigate("/aggiungi-contenuti");
            return;
        }
        
        loadExistingTemplate();
    }, [courseData]);

    const loadExistingTemplate = async () => {
        try {
            const template = await getSurveyTemplateByIdContenuto({id_contenuto: selectedContenuto.id_contenuto});
            if (template) {
                setExistingTemplate(template);
                templateRef.current = { isNew: false, id: template.id_survey_template };
            }
        } catch (error) {
            console.error('Errore nel caricamento del template:', error);
        } finally {
            setLoading(false);
        }
    };

    const saveSurvey = async (surveyJson) => {
        const surveyTemplate = {
            id_corso: courseData.id_corso,
            id_contenuto: selectedContenuto.id_contenuto,
            id_area: selectedContenuto.id_area,
            titolo: surveyJson.title || "Quiz senza titolo",
            descrizione: surveyJson.description || "",
            json_definition: JSON.stringify(surveyJson),
            tipo: "quiz",
            max_time_to_finish: surveyJson.maxTimeToFinish || null,
            max_time_to_finish_page: surveyJson.maxTimeToFinishPage || null,
            show_progress_bar: surveyJson.showProgressBar || false,
            show_timer_panel: surveyJson.showTimerPanel || false
        };

        try {
            if (templateRef.current.isNew || templateRef.current.id) {
                surveyTemplate.id_survey_template = templateRef.current.id;
                const response = await updateSurveyTemplate(surveyTemplate);
                if (response) {
                    setExistingTemplate(response);
                }
            } else {
                const response = await createSurveyTemplate(surveyTemplate);
                if (response) {
                    templateRef.current = { isNew: true, id: response.id_survey_template };
                    setExistingTemplate(response);
                }
            }
        } catch (error) {
            console.error('Errore nel salvataggio:', error);
        }
    };

    if (loading) {
        return (
            <div className="text-center p-5">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Caricamento...</span>
                </Spinner>
            </div>
        );
    }

    return (
        <div className={"surveyContainer"}>
            <SurveyManager 
                json={existingTemplate ? JSON.parse(existingTemplate.json_definition) : json} 
                saveSurvey={saveSurvey} 
                options={options}
                onCreatorReady={onCreatorReady}
            />
        </div>
    );
}

export default SurveyCreatorPage;
